import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import { categories, hotTags } from '@/mocks/categories';
import { getLatestArticles, getHotArticles, getArticlesByCategory } from '@/mocks/articles';

export default function Home() {
  const latestArticles = getLatestArticles(12);
  const hotArticles = getHotArticles();
  const celebrityArticles = getArticlesByCategory('mingxing').slice(0, 4);
  const influencerArticles = getArticlesByCategory('wanghong').slice(0, 4);
  const entertainmentArticles = getArticlesByCategory('yulequan').slice(0, 4);
  const socialArticles = getArticlesByCategory('shehui').slice(0, 4);

  const homeJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '51黑料 - 最新热门黑料爆料聚合平台',
    description: '专注收录互联网热门黑料、爆料内容的聚合平台，汇聚娱乐圈、网红、明星最新黑料资讯，实时更新，一键直达全网最劲爆内容。',
    url: 'https://51heiliao.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '51黑料',
      url: 'https://51heiliao.com/',
    },
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: latestArticles.slice(0, 10).map((article, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        url: `https://51heiliao.com/article/${article.slug}`,
        name: article.title,
      })),
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '51黑料是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51黑料是国内领先的娱乐八卦与黑料爆料聚合平台，致力于为网友提供最新、最全、最劲爆的娱乐圈黑料资讯，覆盖明星黑料、网红爆料、娱乐圈内幕、社会热点等多个领域。',
        },
      },
      {
        '@type': 'Question',
        name: '51黑料的内容更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51黑料平台全天24小时实时更新，日均爆料更新超过200条。编辑团队全天候监测全网热点，确保用户能在第一时间获取最新爆料资讯。',
        },
      },
      {
        '@type': 'Question',
        name: '51黑料的内容来源可靠吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51黑料拥有一支专业的编辑团队和遍布全网的信息采集网络，能够对信息的真实性和可靠性进行交叉验证。平台始终坚持"真实、快速、全面"的内容理念。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在51黑料上找到感兴趣的内容？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51黑料提供多种内容发现方式：可通过首页热搜榜单查看当前最热门的内容，通过分类导航浏览明星、网红、娱乐圈等不同领域，也可使用搜索功能直接查找感兴趣的爆料。',
        },
      },
      {
        '@type': 'Question',
        name: '51黑料最新入口在哪里？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51黑料的官方入口为51heiliao.com。用户通过该域名可直接访问51黑料聚合平台的最新内容，建议收藏以便随时获取最新爆料资讯。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="51黑料 - 最新热门黑料爆料聚合平台"
        description="51黑料是专注收录互联网热门黑料、爆料内容的聚合平台，汇聚娱乐圈、网红、明星最新黑料资讯，实时更新，一键直达全网最劲爆的51黑料内容，让你第一时间掌握热点真相。"
        keywords="51黑料,51黑料最新,51黑料爆料,51黑料网红,51黑料明星,51黑料入口,51黑料聚合,黑料爆料,娱乐圈八卦,网红黑料"
        ogImage="https://readdy.ai/api/search-image?query=Breaking%20news%20and%20gossip%20aggregation%20platform%20homepage%20with%20dramatic%20red%20accents%20and%20modern%20layout%2C%20news%20media%20branding%2C%20professional%20design&width=1200&height=630&seq=og-home&orientation=landscape"
      />

      <script type="application/ld+json">{JSON.stringify(homeJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20newsroom%20background%20with%20red%20spotlight%20beams%20and%20breaking%20news%20atmosphere%2C%20cinematic%20journalism%20theme%2C%20intense%20dramatic%20lighting%2C%20professional%20broadcast%20studio%20feel%2C%20dark%20and%20moody%20with%20crimson%20accents&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
            alt="51黑料 - 最新热门黑料爆料聚合平台"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-background-50 text-sm font-medium rounded-full mb-6 backdrop-blur-sm whitespace-nowrap">
              <i className="ri-fire-line mr-1.5"></i>实时更新 · 全网最劲爆
            </span>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
              51黑料 - 最新热门黑料<br className="hidden sm:block" />爆料聚合平台
            </h1>
            <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
              汇聚娱乐圈、网红、明星最新黑料资讯，实时更新，一键直达全网最劲爆的51黑料内容，让你第一时间掌握热点真相
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/zuixin"
                className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all whitespace-nowrap"
              >
                <i className="ri-flashlight-line mr-2"></i>查看最新爆料
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-lg transition-all backdrop-blur-sm whitespace-nowrap"
              >
                <i className="ri-information-line mr-2"></i>了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Hot Tags Bar */}
        <section className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
            <div className="flex items-center gap-3">
              <span className="flex items-center gap-1.5 text-sm font-medium text-primary-600 whitespace-nowrap">
                <i className="ri-fire-line"></i>热搜
              </span>
              <div className="flex items-center gap-2 overflow-x-auto scrollbar-hide flex-1">
                {hotTags.map((tag, index) => (
                  <Link
                    key={index}
                    to={`/category/zuixin`}
                    className={`flex-shrink-0 px-3 py-1 text-xs rounded-full whitespace-nowrap transition-colors ${
                      index < 3
                        ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                        : 'bg-background-200/70 text-foreground-600 hover:bg-background-300'
                    }`}
                  >
                    {index < 3 && <span className="text-primary-500 font-bold mr-1">{index + 1}</span>}
                    {tag}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Main Content Area */}
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Left: Latest Articles */}
            <div className="flex-1">
              <div className="flex items-center justify-between mb-6">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  <i className="ri-flashlight-line text-primary-500 mr-2"></i>最新爆料
                </h2>
                <Link to="/category/zuixin" className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap">
                  查看全部 <i className="ri-arrow-right-line ml-1"></i>
                </Link>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                {latestArticles.map((article, index) => (
                  <article key={article.id} className={`bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all group ${index === 0 ? 'sm:col-span-2' : ''}`}>
                    <Link to={`/article/${article.slug}`} className="block">
                      <div className={`relative overflow-hidden ${index === 0 ? 'aspect-[21/9]' : 'aspect-[16/9]'}`}>
                        <img
                          src={article.image}
                          alt={article.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          loading={index > 2 ? 'lazy' : undefined}
                        />
                        {article.isHot && (
                          <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                            <i className="ri-fire-line mr-1"></i>热门
                          </span>
                        )}
                        {article.isNew && (
                          <span className="absolute top-3 right-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                            NEW
                          </span>
                        )}
                      </div>
                      <div className="p-4">
                        <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                          <span className="px-2 py-0.5 bg-primary-50 text-primary-700 rounded whitespace-nowrap">{article.categoryName}</span>
                          <span>{article.date}</span>
                          <span><i className="ri-eye-line mr-1"></i>{(article.views / 10000).toFixed(1)}万</span>
                        </div>
                        <h3 className={`font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2 ${index === 0 ? 'text-lg md:text-xl' : 'text-base'}`}>
                          {article.title}
                        </h3>
                        <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                          {article.excerpt}
                        </p>
                      </div>
                    </Link>
                  </article>
                ))}
              </div>
            </div>

            {/* Right: Hot List Sidebar */}
            <aside className="w-full lg:w-[340px] flex-shrink-0">
              <div className="bg-background-100 rounded-lg border border-background-200/70 p-5 sticky top-20">
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-4 flex items-center gap-2">
                  <i className="ri-fire-line text-primary-500"></i>热门榜单
                </h3>
                <div className="space-y-1">
                  {hotArticles.map((article, index) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.slug}`}
                      className="flex items-start gap-3 p-3 rounded-lg hover:bg-background-200/50 transition-colors group"
                    >
                      <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded text-xs font-bold ${
                        index < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-300 text-foreground-600'
                      }`}>
                        {index + 1}
                      </span>
                      <div className="flex-1 min-w-0">
                        <h4 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                          {article.title}
                        </h4>
                        <span className="text-xs text-foreground-400 mt-1 block">{article.views.toLocaleString()} 次阅读</span>
                      </div>
                    </Link>
                  ))}
                </div>

                <div className="mt-5 pt-4 border-t border-background-200/70">
                  <h4 className="text-sm font-semibold text-foreground-700 mb-3">热门标签</h4>
                  <div className="flex flex-wrap gap-2">
                    {hotTags.slice(0, 8).map((tag, i) => (
                      <Link
                        key={i}
                        to="/category/zuixin"
                        className="px-3 py-1 text-xs bg-background-200/70 text-foreground-600 rounded-full hover:bg-primary-100 hover:text-primary-700 transition-colors whitespace-nowrap"
                      >
                        {tag}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </div>

        {/* Category Sections */}
        <section className="bg-background-100 py-12 md:py-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10">
              <i className="ri-grid-line text-primary-500 mr-2"></i>分类浏览
            </h2>

            {/* Category: 明星爆料 */}
            <div className="mb-12">
              <div className="flex items-center justify-between mb-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950 flex items-center gap-2">
                  <i className="ri-star-line text-primary-500"></i>明星爆料
                </h3>
                <Link to="/category/mingxing" className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap">
                  更多 <i className="ri-arrow-right-line ml-1"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {celebrityArticles.map((article) => (
                  <article key={article.id} className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all group">
                    <Link to={`/article/${article.slug}`} className="block">
                      <div className="aspect-[16/9] overflow-hidden">
                        <img src={article.image} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                      </div>
                      <div className="p-3">
                        <h4 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                          {article.title}
                        </h4>
                        <span className="text-xs text-foreground-400 mt-1 block">{article.date}</span>
                      </div>
                    </Link>
                  </article>
                ))}
              </div>
            </div>

            {/* Category: 网红黑料 */}
            <div className="mb-12">
              <div className="flex items-center justify-between mb-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950 flex items-center gap-2">
                  <i className="ri-live-line text-primary-500"></i>网红黑料
                </h3>
                <Link to="/category/wanghong" className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap">
                  更多 <i className="ri-arrow-right-line ml-1"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {influencerArticles.map((article) => (
                  <article key={article.id} className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all group">
                    <Link to={`/article/${article.slug}`} className="block">
                      <div className="aspect-[16/9] overflow-hidden">
                        <img src={article.image} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                      </div>
                      <div className="p-3">
                        <h4 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                          {article.title}
                        </h4>
                        <span className="text-xs text-foreground-400 mt-1 block">{article.date}</span>
                      </div>
                    </Link>
                  </article>
                ))}
              </div>
            </div>

            {/* Category: 娱乐圈 + 社会热点 */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div>
                <div className="flex items-center justify-between mb-5">
                  <h3 className="font-heading text-lg font-bold text-foreground-950 flex items-center gap-2">
                    <i className="ri-movie-line text-primary-500"></i>娱乐圈
                  </h3>
                  <Link to="/category/yulequan" className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap">
                    更多 <i className="ri-arrow-right-line ml-1"></i>
                  </Link>
                </div>
                <div className="space-y-3">
                  {entertainmentArticles.map((article) => (
                    <Link key={article.id} to={`/article/${article.slug}`} className="flex items-start gap-3 p-3 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all group">
                      <div className="w-20 h-14 flex-shrink-0 rounded overflow-hidden">
                        <img src={article.image} alt={article.title} className="w-full h-full object-cover" loading="lazy" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                          {article.title}
                        </h4>
                        <span className="text-xs text-foreground-400 mt-1 block">{article.date}</span>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>

              <div>
                <div className="flex items-center justify-between mb-5">
                  <h3 className="font-heading text-lg font-bold text-foreground-950 flex items-center gap-2">
                    <i className="ri-fire-line text-primary-500"></i>社会热点
                  </h3>
                  <Link to="/category/shehui" className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap">
                    更多 <i className="ri-arrow-right-line ml-1"></i>
                  </Link>
                </div>
                <div className="space-y-3">
                  {socialArticles.map((article) => (
                    <Link key={article.id} to={`/article/${article.slug}`} className="flex items-start gap-3 p-3 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all group">
                      <div className="w-20 h-14 flex-shrink-0 rounded overflow-hidden">
                        <img src={article.image} alt={article.title} className="w-full h-full object-cover" loading="lazy" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                          {article.title}
                        </h4>
                        <span className="text-xs text-foreground-400 mt-1 block">{article.date}</span>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Category Quick Nav */}
        <section className="bg-background-50 py-10 md:py-14">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
              快速导航
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex flex-col items-center gap-3 p-6 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all group"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{cat.name}</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* SEO Content Section */}
        <section className="bg-background-100 py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <article className="prose-custom">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
                关于51黑料爆料聚合平台
              </h2>
              <div className="space-y-5 text-sm text-foreground-600 leading-relaxed">
                <p>
                  <strong>51黑料</strong>是国内领先的娱乐八卦与<strong>黑料爆料</strong>聚合平台，致力于为网友提供最新、最全、最劲爆的娱乐圈<strong>黑料资讯</strong>。自成立以来，51黑料始终坚持"真实、快速、全面"的内容理念，汇聚来自全网的热门爆料信息，覆盖<strong>明星黑料</strong>、<strong>网红爆料</strong>、娱乐圈内幕、<strong>社会热点</strong>等多个领域。
                </p>
                <p>
                  无论你是在寻找<strong>51黑料最新</strong>动态，还是想看<strong>51黑料网红</strong>和<strong>51黑料明星</strong>的独家揭秘，51黑料聚合平台都能满足你的需求。我们的编辑团队全天候监测全网热点，确保你第一时间获取<strong>51黑料爆料</strong>内容。通过<strong>51黑料入口</strong>，你可以轻松浏览各大分类的精彩内容，一键直达全网最劲爆的爆料。
                </p>
                <p>
                  51黑料平台汇聚了海量<strong>黑料</strong>资源，分类清晰、更新及时。从娱乐圈明星的私生活揭秘到网红博主的翻车现场，从热播综艺的幕后黑幕到社会热点事件的深度追踪，<strong>51黑料聚合</strong>平台为你呈现最全面的爆料视角。我们相信，真相值得被看见，每一个吃瓜群众都应有了解真相的权利。
                </p>
              </div>

              <div className="mt-10">
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-4 text-center">常见问题</h3>
                <div className="space-y-4">
                  <div className="bg-background-50 rounded-lg p-5 border border-background-200/70">
                    <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">51黑料是什么？</h4>
                    <p className="text-sm text-foreground-600">51黑料是一个专注收录互联网热门黑料、爆料内容的聚合平台，汇聚明星、网红、娱乐圈最新资讯。</p>
                  </div>
                  <div className="bg-background-50 rounded-lg p-5 border border-background-200/70">
                    <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">51黑料的内容更新频率如何？</h4>
                    <p className="text-sm text-foreground-600">51黑料全天24小时实时更新，日均爆料更新超过200条，确保用户第一时间获取最新内容。</p>
                  </div>
                  <div className="bg-background-50 rounded-lg p-5 border border-background-200/70">
                    <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">51黑料最新入口在哪里？</h4>
                    <p className="text-sm text-foreground-600">51黑料的官方入口为51heiliao.com，建议收藏以便随时访问51黑料聚合平台的最新爆料内容。</p>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </section>
      </main>
    </>
  );
}